(function () {
  const initCollapsibleContent = () => {
    // Handle FAQ toggles
    $(".collapsible-content__toggle").each(function (index, element) {
      if ($(this).hasClass("content_started")) {
        return "";
      }
      $(this).addClass("content_started");
      $(element).on("click", function () {
        const parent = $(this).parent();
        if (!parent.hasClass("active")) {
          parent.siblings(".collapsible-content__item.active").removeClass("active");
          parent.addClass("active");
          $(this)
            .closest(".collapsible-content__items")
            .find(".collapsible-content__answer")
            .stop()
            .slideUp(300);
          $(this).next().stop().slideDown(300);
        } else {
          parent.removeClass("active");
          $(this).next().stop().slideUp(300);
        }
      });
    });

    // Handle hover effects
    $(".collapsible-content__item").mouseenter(function (event) {
      const element = $(this);
      element.removeClass("collapsible-content__item--opacity");
      element.siblings().addClass("collapsible-content__item--opacity");
      element.mouseleave(() => {
        element.siblings().removeClass("collapsible-content__item--opacity");
      });
    });

    // Handle category filtering
    $(".category-filter").on("click", function() {
      const category = $(this).data("category");
      
      // Update active class on filter buttons
      $(".category-filter").removeClass("active");
      $(this).addClass("active");
      
      if (category === "all") {
        // Show all FAQ items
        $(".collapsible-content__item").show();
      } else {
        // Hide all items, then show only those matching the selected category
        $(".collapsible-content__item").hide();
        $(`.collapsible-content__item[data-category="${category}"]`).show();
      }
      
      // Close any open accordions
      $(".collapsible-content__item.active").removeClass("active");
      $(".collapsible-content__answer").slideUp(300);
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    initCollapsibleContent();
    document.addEventListener("shopify:section:load", function () {
      initCollapsibleContent();
    });
  });
})();